<template>
    <div>
        <div class="content-box">
            <div class="tabel-box">
                <div class="centent-comment-title">节段脂肪<span class="centent-comment-title-unit">&nbsp;kg</span></div>
                <div>
                    <img class="content-img" src="../assets/ic-segments-bg.png" />

                    <div style=" display: flex; position: relative;  width: 20px; left: 30px; top: -140px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.11</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; right:-110px; top: -170px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.2</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; left:30px; top: -115px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.3</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; right:-110px; top: -147px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.2</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; left:70px; top: -225px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.2</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tabel-box" style="margin-left: 10px;">
                <div class="centent-comment-title">节段肌肉<span class="centent-comment-title-unit">&nbsp;kg</span></div>
                <div>
                    <img class="content-img" src="../assets/ic-segments-bg.png" />

                    <div style=" display: flex; position: relative;  width: 20px; left: 30px; top: -140px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.1</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; right:-110px; top: -170px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.2</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; left:30px; top: -115px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.3</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>

                    <div style="  position: relative;  width: 20px; right:-110px; top: -147px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.2</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>
                    <div style="  position: relative;  width: 20px; left:70px; top: -225px; ">
                        <div style="display: flex; flex-direction: column; ">
                            <span class="content-item-top-title">0.2</span>
                            <span class="content-item-bottom-title">标准</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
.content-box {
    display: flex;
    width: 383px;
}

.tabel-box {
    display: flex;
    flex-direction: column;
    background: #fff;
    width: 187px;
    height: 200px;
    padding: 13px;
    margin-top: 10px;
}

.centent-comment-title {
    font-size: 19px;
    color: #333333;
    font-weight: bold;
    text-align: left;
}

.centent-comment-title-unit {
    font-weight: 400;
    font-size: 17px;
    color: #333333;
}

.content-img {
    width: 161px;
    height: 173px;
    margin-top: 5px;
}

.content-item-top-title {
    font-weight: 500;
    font-size: 13px;
    color: #00BA8D;
}

.content-item-bottom-title {
    font-weight: 400;
    font-size: 9px;
    color: #333333;
}
</style>